// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.car-selection-table {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
}

.table-toolbar {
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 0;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  padding: 8px 12px;
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #94a3b8;
}

.search-box svg {
  flex-shrink: 0;
}

.search-input {
  flex: 1 1;
  background: none;
  border: none;
  color: #e2e8f0;
  font-size: 14px;
  outline: none;
}

.search-input::placeholder {
  color: #64748b;
}

.show-selected-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  cursor: pointer;
  color: #cbd5e1;
  font-size: 14px;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.show-selected-checkbox input {
  cursor: pointer;
  width: 18px;
  height: 18px;
}

.show-selected-checkbox:hover {
  border-color: #475569;
  background-color: #334155;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #334155;
  border-radius: 6px;
  background-color: #1e293b;
  max-height: 500px;
  overflow-y: auto;
}

.cars-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.cars-table thead {
  background-color: #0f172a;
  position: sticky;
  top: 0;
  z-index: 10;
}

.cars-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #cbd5e1;
  border-bottom: 1px solid #334155;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s;
}

.cars-table th:hover {
  background-color: #1e293b;
}

.cars-table th .header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sort-icon {
  flex-shrink: 0;
  color: #60a5fa;
}

.col-checkbox {
  width: 50px;
  text-align: center;
}

.col-name {
  flex: 1 1;
  min-width: 200px;
}

.col-performance {
  width: 150px;
  text-align: center;
}

.col-ballast {
  width: 140px;
  text-align: center;
}

.col-restrictor {
  width: 140px;
  text-align: center;
}

.cars-table tbody tr {
  border-bottom: 1px solid #334155;
  transition: background-color 0.2s;
}

.cars-table tbody tr:hover {
  background-color: #334155;
}

.cars-table tbody tr.selected {
  background-color: #1e3a8a;
}

.cars-table tbody tr.selected:hover {
  background-color: #1e40af;
}

.cars-table td {
  padding: 12px;
  color: #e2e8f0;
}

.cars-table td input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.config-input {
  width: 100%;
  padding: 6px 8px;
  background-color: #0f172a;
  border: 1px solid #475569;
  border-radius: 4px;
  color: #e2e8f0;
  font-size: 14px;
  text-align: center;
  outline: none;
  transition: border-color 0.2s;
}

.config-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

.disabled-value {
  color: #64748b;
  font-size: 13px;
}

.no-results {
  background-color: #1e293b !important;
}

.no-results td {
  text-align: center;
  color: #64748b;
  padding: 32px 12px;
  font-style: italic;
}

.table-footer {
  padding: 8px 0;
  text-align: right;
}

.cars-count {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
}

/* Scrollbar styling */
.table-wrapper::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
  background-color: #0f172a;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background-color: #475569;
  border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #64748b;
}

/* Property Filters */
.property-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  padding: 12px;
  background-color: #0f172a;
  border: 1px solid #334155;
  border-radius: 6px;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-label {
  font-weight: 600;
  color: #cbd5e1;
  font-size: 14px;
  min-width: 80px;
}

.filter-options {
  display: flex;
  gap: 8px;
}

.filter-button {
  padding: 6px 12px;
  background-color: #1e293b;
  border: 1px solid #475569;
  border-radius: 4px;
  color: #cbd5e1;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.filter-button:hover {
  border-color: #64748b;
  background-color: #334155;
}

.filter-button.active {
  background-color: #3b82f6;
  border-color: #3b82f6;
  color: #ffffff;
  font-weight: 500;
}

.filter-button.active:hover {
  background-color: #2563eb;
  border-color: #2563eb;
}

.clear-filters-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #7c3aed;
  border: 1px solid #7c3aed;
  border-radius: 4px;
  color: #ffffff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  margin-left: auto;
}

.clear-filters-btn:hover {
  background-color: #6d28d9;
  border-color: #6d28d9;
}
`, "",{"version":3,"sources":["webpack://./src/components/CarSelectionTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".car-selection-table {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 0;\r\n}\r\n\r\n.table-toolbar {\r\n  display: flex;\r\n  gap: 16px;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.search-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex: 1;\r\n  padding: 8px 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  color: #94a3b8;\r\n}\r\n\r\n.search-box svg {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  background: none;\r\n  border: none;\r\n  color: #e2e8f0;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: #64748b;\r\n}\r\n\r\n.show-selected-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  color: #cbd5e1;\r\n  font-size: 14px;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.show-selected-checkbox input {\r\n  cursor: pointer;\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.show-selected-checkbox:hover {\r\n  border-color: #475569;\r\n  background-color: #334155;\r\n}\r\n\r\n.table-wrapper {\r\n  overflow-x: auto;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  background-color: #1e293b;\r\n  max-height: 500px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.cars-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 14px;\r\n}\r\n\r\n.cars-table thead {\r\n  background-color: #0f172a;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.cars-table th {\r\n  padding: 12px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #cbd5e1;\r\n  border-bottom: 1px solid #334155;\r\n  cursor: pointer;\r\n  user-select: none;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.cars-table th:hover {\r\n  background-color: #1e293b;\r\n}\r\n\r\n.cars-table th .header-content {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.sort-icon {\r\n  flex-shrink: 0;\r\n  color: #60a5fa;\r\n}\r\n\r\n.col-checkbox {\r\n  width: 50px;\r\n  text-align: center;\r\n}\r\n\r\n.col-name {\r\n  flex: 1;\r\n  min-width: 200px;\r\n}\r\n\r\n.col-performance {\r\n  width: 150px;\r\n  text-align: center;\r\n}\r\n\r\n.col-ballast {\r\n  width: 140px;\r\n  text-align: center;\r\n}\r\n\r\n.col-restrictor {\r\n  width: 140px;\r\n  text-align: center;\r\n}\r\n\r\n.cars-table tbody tr {\r\n  border-bottom: 1px solid #334155;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.cars-table tbody tr:hover {\r\n  background-color: #334155;\r\n}\r\n\r\n.cars-table tbody tr.selected {\r\n  background-color: #1e3a8a;\r\n}\r\n\r\n.cars-table tbody tr.selected:hover {\r\n  background-color: #1e40af;\r\n}\r\n\r\n.cars-table td {\r\n  padding: 12px;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.cars-table td input[type=\"checkbox\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n  cursor: pointer;\r\n}\r\n\r\n.config-input {\r\n  width: 100%;\r\n  padding: 6px 8px;\r\n  background-color: #0f172a;\r\n  border: 1px solid #475569;\r\n  border-radius: 4px;\r\n  color: #e2e8f0;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.config-input:focus {\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.disabled-value {\r\n  color: #64748b;\r\n  font-size: 13px;\r\n}\r\n\r\n.no-results {\r\n  background-color: #1e293b !important;\r\n}\r\n\r\n.no-results td {\r\n  text-align: center;\r\n  color: #64748b;\r\n  padding: 32px 12px;\r\n  font-style: italic;\r\n}\r\n\r\n.table-footer {\r\n  padding: 8px 0;\r\n  text-align: right;\r\n}\r\n\r\n.cars-count {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.table-wrapper::-webkit-scrollbar {\r\n  height: 8px;\r\n  width: 8px;\r\n}\r\n\r\n.table-wrapper::-webkit-scrollbar-track {\r\n  background-color: #0f172a;\r\n}\r\n\r\n.table-wrapper::-webkit-scrollbar-thumb {\r\n  background-color: #475569;\r\n  border-radius: 4px;\r\n}\r\n\r\n.table-wrapper::-webkit-scrollbar-thumb:hover {\r\n  background-color: #64748b;\r\n}\r\n\r\n/* Property Filters */\r\n.property-filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  align-items: center;\r\n  padding: 12px;\r\n  background-color: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n}\r\n\r\n.filter-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.filter-label {\r\n  font-weight: 600;\r\n  color: #cbd5e1;\r\n  font-size: 14px;\r\n  min-width: 80px;\r\n}\r\n\r\n.filter-options {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.filter-button {\r\n  padding: 6px 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 4px;\r\n  color: #cbd5e1;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n  user-select: none;\r\n}\r\n\r\n.filter-button:hover {\r\n  border-color: #64748b;\r\n  background-color: #334155;\r\n}\r\n\r\n.filter-button.active {\r\n  background-color: #3b82f6;\r\n  border-color: #3b82f6;\r\n  color: #ffffff;\r\n  font-weight: 500;\r\n}\r\n\r\n.filter-button.active:hover {\r\n  background-color: #2563eb;\r\n  border-color: #2563eb;\r\n}\r\n\r\n.clear-filters-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  background-color: #7c3aed;\r\n  border: 1px solid #7c3aed;\r\n  border-radius: 4px;\r\n  color: #ffffff;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n  user-select: none;\r\n  margin-left: auto;\r\n}\r\n\r\n.clear-filters-btn:hover {\r\n  background-color: #6d28d9;\r\n  border-color: #6d28d9;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
